import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import ATFMemberSearchForm from "webapp/components/Partner/ATF/ATFMemberSearchForm/ATFMembersearchForm";
import { BMOMemberSearchForm } from "webapp/components/Partner/BMO/BMOMemberSearchForm/Index";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function BMOMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [firstName, setFirstName] = useState(
    props.context.state.MemberLookup.firstName || props.context.state.FirstName || "",
  );

  const [lastName, setLastName] = useState(
    props.context.state.MemberLookup.lastName || props.context.state.LastName || "",
  );

  const [coverageType, setCoverageType] = useState(
    props.context.state.MemberLookup.coverageType || props.context.state.coverageType || "",
  );

  const [searchType, setSearchType] = useState(
    props.context.state.MemberLookup.searchType || props.context.state.searchType || "",
  );

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.firstName === "string") {
        setFirstName(data.firstName);
      }
      if (typeof data.lastName === "string") {
        setLastName(data.lastName);
      }
      if (typeof data.coverageType === "string") {
        setCoverageType(data.coverageType);
      }
      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        // FirstName: firstName,
        // LastName: lastName,
        webAppState: nextState,
        MemberLookup: {
          firstName: data.firstName,
          lastName: data.lastName,
          coverageType: data.coverageType,
          searchType: data.searchType,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.BMOMemberSearchTitle")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("BWC.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <BMOMemberSearchForm
        firstName={firstName}
        lastName={lastName}
        coverageType={coverageType}
        searchType={searchType}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
      />
    </div>
  );
}

export default BMOMemberSearch;
